<template>
  <div>
    <v-progress-linear
      v-if="loading && !products"
      indeterminate
      color="rgb(86, 160, 153)"
      style="margin-top:20px;"
    />
    <v-data-table
      :headers="headers"
      :items="products"
      sort-by="calories"
      class="elevation-1"
      v-if="products"
      :items-per-page="itemsPerPage"
      :loading="loading"
      hideDefaultFooter
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>{{$t('products.title')}}</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          />
          <!-- <v-spacer /> -->
          <v-btn v-if="products" @click="handleExportToPDF"><v-icon>mdi-file-pdf</v-icon></v-btn>
          <v-divider
            class="mx-4"
            inset
            vertical
          />
          <v-select
            solo
            :label="$t('menus.name')"
            v-if="menusFilter"
            v-model="menuFilterSelected"
            :items="menusFilter"
            item-text="Name"
            item-value="ID"
            style="margin-top:30px;margin-right: 5px;"
            @change="handleChangeFilterSelected"
          />
          <v-text-field
            solo
            :label="$t('common.search')"
            append-icon="mdi-magnify"
            style="margin-top:30px;"
            v-model="search"
            @input="handleSearch"
          />
          <v-spacer /> 
          <form-products :dialog="dialog" :data="editedItem" 
            :onSave="handleSave"
            :onClose="handleClose"
          />
        </v-toolbar>
      </template>
      <template v-slot:item.HideMobile="{ item }">
        <center>
          <v-icon v-if="item.HideMobile" @click="handleChangeHideAll(item.MenuContentID, false)">mdi-eye-off</v-icon>
          <v-icon v-else  @click="handleChangeHideAll(item.MenuContentID, true)">mdi-eye</v-icon>
        </center>
      </template>
      <template v-slot:item.ProductPromotion="{ item }">
        <center>
          <v-checkbox
            v-model="item.ProductPromotion"
            :value="item.ProductPromotion"
            @change="handleChangePromotion(item)"
          />
        </center>
      </template>
      <!-- <template v-slot:item.FoodVegetarian="{ item }">
        <center>
          <v-checkbox
            v-model="item.FoodVegetarian"
            :value="item.FoodVegetarian"
            @change="handleChangeVegetarian(item)"
          />
        </center>
      </template>
      <template v-slot:item.FoodNew="{ item }">
        <center>
          <v-checkbox
            v-model="item.FoodNew"
            :value="item.FoodNew"
            @change="handleChangeNew(item)"
          />
        </center>
      </template>
      <template v-slot:item.FoodRecommended="{ item }">
        <center>
          <v-checkbox
            v-model="item.FoodRecommended"
            :value="item.FoodRecommended"
            @change="handleChangeRecommended(item)"
          />
        </center>
      </template> -->
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          @click="handleDeleteItem(item.MenuContentID)"
        >
          mdi-delete
        </v-icon>
      </template>
      <!-- <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template> -->
    </v-data-table>
    <v-layout wrap>
      <v-flex xs2>
        <v-select
            solo
            :label="$t('common.show')"
            v-model="itemsPerPage"
            :items="[
              { ID: 100000, Name: 'All'},
              { ID: 5, Name: '5'},
              { ID: 10, Name: '10'},
              { ID: 25, Name: '25'},
            ]"
            item-text="Name"
            item-value="ID"
            @change="getProducts"
            style="margin: 5px;"
          />
      </v-flex>
      <v-flex xs10 
        v-if="pageCount > 0"
        style="padding-left: 10px;padding-right: 10px;"
      >
        <v-pagination
          v-model="page"
          :length="pageCount"
          @input="handleChangePage"
        />
      </v-flex>
    </v-layout>
    
  </div>
</template>

<script>
  import jsPDF from 'jspdf'
  import 'jspdf-autotable'
  import _ from 'lodash'
  import api from '@/services/api'
  import utils from '@/services/utils'
  import i18n from '@/plugins/i18n'
  import FormProducts from './FormProducts'
  export default {
    components: {
      FormProducts
    },
    data: () => ({
      menusFilter: [],
      menuFilterSelected: null,
      page: 1,
      loading: false,
      search: '',
      dialog: false,
      itemsPerPage: 10,
      allergens: null,
      pageCount: 0,
      headers: [
        {
          text: '',
          align: 'start',
          sortable: true,
          value: 'HideMobile',
        },
        {
          text: i18n.t('dishes.menu'),
          align: 'start',
          sortable: true,
          value: 'MenuNameFormatted',
        },
        {
          text: i18n.t('product.name'),
          align: 'start',
          sortable: true,
          value: 'ProductNameFormatted',
        },
        {
          text: i18n.t('product.description'),
          align: 'start',
          sortable: true,
          value: 'ProductDescriptionFormatted',
        },
        {
          text: i18n.t('product.price'),
          align: 'start',
          sortable: true,
          value: 'ProductPrice',
        },
        {
          text: i18n.t('product.promotion'),
          align: 'start',
          sortable: true,
          value: 'ProductPromotion',
        },
        // {
        //   text: i18n.t('dishes.vegetarian'),
        //   align: 'start',
        //   sortable: true,
        //   value: 'FoodVegetarian',
        // },
        // {
        //   text: i18n.t('food.new'),
        //   align: 'start',
        //   sortable: true,
        //   value: 'FoodNew',
        // },
        // {
        //   text: i18n.t('food.recommended'),
        //   align: 'start',
        //   sortable: true,
        //   value: 'FoodRecommended',
        // },
        // { text: i18n.t('dishes.allergens'), value: 'FoodAllergens' },
        // { text: 'Calories', value: 'calories' },
        // { text: 'Fat (g)', value: 'fat' },
        // { text: 'Carbs (g)', value: 'carbs' },
        // { text: 'Protein (g)', value: 'protein' },
        { text: '', value: 'actions', sortable: false },
      ],
      products: null,
      editedIndex: -1,
      editedItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
        FoodAllergens: []
      },
    }),
    computed: {
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      locale () {
        return i18n.locale
      },
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
      // pageCount () {
      //   let page = this.count > 0 ? parseInt(this.count / this.itemsPerPage, 10) : 0
      //   if (this.count > 0 && (this.count % this.itemsPerPage)!== 0) page++
      //   return page
      // },
    },

    watch: {
      dialog (val) {
        val || this.handleClose()
      },
      enterpriseID (newValue, oldValue) {
        if (oldValue !== newValue && newValue) this.getMenusFilter ()
      }
    },

    // created () {
    //   this.initialize()
    // },
    mounted () {
      if (this.enterpriseID) this.getMenusFilter ()
      this.loading = true
      this.handleSearch = _.debounce(() => {
        this.getProducts()        
      }, 500)
      this.initialize()
    },
    methods: {
      getMenusFilter () {
        api.getAll(`contents/${this.enterpriseID}/products-menu`, true).then(response => {
          this.menusFilter = response.map(item => {
            item.Name = utils.getTranslation(JSON.parse(item.Name), this.locale) 
            return item
          })
          this.menusFilter.unshift({
            ID: '',
            Name: ''
          })
        })
      },
      initialize () {   
        const enterpriseIDDomain = this.$store.state.app.enterpriseID ? this.$store.state.app.enterpriseID : utils.getDomain()
        api.getItem('utils', true, `allergens/${enterpriseIDDomain}`).then(response => {     
          this.allergens = response.data.map(item => {
            item.Name = utils.getTranslation (item.Name, this.locale) 
            return item
          })
          this.getProducts()
        })
      },
      getProducts() {
        this.loading = true
        const aux = this.menuFilterSelected && this.menuFilterSelected.length > 0 ? this.itemsPerPage.toString().concat('&menuFilter=', this.menuFilterSelected) : this.itemsPerPage
        api.getAll(`contents/${this.enterpriseID}/products`, true, this.page, aux, this.search).then(response => {          
          this.loading = false   
          if (response.count) {
            this.count = response.count
            let page = this.count > 0 ? parseInt(this.count / this.itemsPerPage, 10) : 0
            if (this.count > 0 && (this.count % this.itemsPerPage)!== 0) page++
            this.pageCount = page
          }
          
          this.products = response.data.map( item => {
            item.MenuName = JSON.parse(item.MenuName)
            item.ProductName = JSON.parse(item.ProductName)
            item.ProductDescription = JSON.parse(item.ProductDescription)
            item.MenuNameFormatted = utils.getStringETC(utils.getTranslation(item.MenuName, this.locale), 40)
            item.ProductNameFormatted = utils.getStringETC(utils.getTranslation(item.ProductName, this.locale), 40)
            item.ProductDescriptionFormatted = utils.getStringETC(utils.getTranslation(item.ProductDescription, this.locale), 40)
            return item
          })
          // this.onSearch()
        })    
      },
      onSearch () {
        if (this.search.length > 0) {
          this.productsFiltered = this.products.filter(x => 
            JSON.stringify(x.MenuName).toUpperCase().indexOf(this.search.toUpperCase()) >= 0 ||
            JSON.stringify(x.ProductName).toUpperCase().indexOf(this.search.toUpperCase()) >= 0 ||
            JSON.stringify(x.ProductDescription).toUpperCase().indexOf(this.search.toUpperCase()) >= 0
          )
        } else {
          this.productsFiltered = this.products
        }
      },
      handleChangeHideAll (id, hideMobile) {
        const body = {
          Hide: hideMobile
        }
        api.updateItem('contents', id.concat('/hide-all'), body)
          .then(() => {
            this.getProducts()
          })
        .catch(error => {
          console.log('error', error)
        })
      },
      handleChangePromotion (body) {
        body.ProductPromotion = body.ProductPromotion ? true : false
        api.updateItem('contents', body.MenuContentID.concat('/products'), body)
          .then(() => {
            this.getProducts()
          })
        .catch(error => {
          console.log('error', error)
        })
      },      

      editItem (item) {
        this.editedIndex = this.products.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      handleDeleteItem (menuContentID) {
        api.deleteItem('contents', menuContentID).then(response => {
            if (response.status === 200) this.getProducts()
          })
        // const index = this.products.indexOf(item)
        // confirm('Are you sure you want to delete this item?') && this.products.splice(index, 1)
      },

      handleClose () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      handleSave (body) {
        api.updateItem('contents', body.MenuContentID.concat('/products'), body)
          .then(() => {
            this.getProducts()
          })
        .catch(error => {
          console.log('error', error)
        })
        this.handleClose()
      },
      handleExportToPDF () {
        const doc = new jsPDF('l')

        // It can parse html:
        // <table id="my-table"><!-- ... --></table>
        doc.autoTable({ html: '#my-table' })

        const body = []
        for (const item of this.products) {
          body.push([utils.getTranslation(item.MenuName, this.locale), utils.getTranslation(item.ProductName, this.locale), utils.getTranslation(item.ProductDescription, this.locale), item.ProductPrice, item.ProductPromotion ? 'SI' : 'NO'])
        }
        // Or use javascript directly:
        doc.autoTable({
          head: [[i18n.t('dishes.menu'), i18n.t('product.name'), i18n.t('product.description'), i18n.t('product.price'), i18n.t('product.promotion')]],
          body
          // body: [
          //   ['David', 'david@example.com', 'Sweden'],
          //   ['Castille', 'castille@example.com', 'Spain'],
          //   // ...
          // ],
        })

        doc.save('table.pdf')
      },
      handleChangePage () {
        this.getProducts()
      },
      handleChangeFilterSelected () {
        this.page = 1
        this.getProducts()
      }
    },
  }
</script>
